__turbopack_context__.v({
  "header": "ClassView-module-scss-module__83QMPW__header",
  "listContainer": "ClassView-module-scss-module__83QMPW__listContainer",
  "mobileCard": "ClassView-module-scss-module__83QMPW__mobileCard",
  "mobileCardBadge": "ClassView-module-scss-module__83QMPW__mobileCardBadge",
  "mobileCardBody": "ClassView-module-scss-module__83QMPW__mobileCardBody",
  "mobileCardDescription": "ClassView-module-scss-module__83QMPW__mobileCardDescription",
  "mobileCardName": "ClassView-module-scss-module__83QMPW__mobileCardName",
});
